import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import ErrorBoundary from '@/components/base/ErrorBoundary'

const rootElement = document.getElementById('root');

if (!rootElement) {
  document.body.innerHTML = '<div style="padding:40px;text-align:center;font-family:sans-serif;"><h1>Page Error</h1><p>Could not find the app root element.</p></div>';
} else {
  try {
    createRoot(rootElement).render(
      <StrictMode>
        <ErrorBoundary>
          <App />
        </ErrorBoundary>
      </StrictMode>,
    );
  } catch (err) {
    const msg = err instanceof Error ? err.message : 'Unknown error';
    rootElement.innerHTML = `<div style="padding:40px;text-align:center;font-family:sans-serif;"><h1>App Failed to Start</h1><p>${msg}</p><button onclick="location.reload()">Refresh</button></div>`;
  }
}